<template>
  <div>
    <Header />
    <HeroDetails @currentSliderPage="handleSlidePage" />
    <Footer />
    <SocialLinks :bordered="borderedSocial" right="5" />
  </div>
</template>

<script>
  import Header from '../components/common/Header'
  import HeroDetails from '../components/Home/HeroDetails'
  import Footer from '../components/common/Footer'
  import SocialLinks from '../components/common/SocialLinks'

  export default {
    name: 'Home',
    metaInfo: {
      title: 'Welcome',
    },
    data() {
      return {
        borderedSocial: false
      }
    },
    components: {
      Header,
      HeroDetails,
      Footer,
      SocialLinks
    },
    methods: {
      handleSlidePage(currentPage) {
        this.borderedSocial = [3,4].includes(currentPage)
      }
    }
  }
</script>

<style>
/* Modal Styles */
#home-modal .modal-content {
  background: transparent;
  border: none;
}
#home-modal .modal-backdrop.show {
  opacity: .75
}
#home-modal .modal-header button.close {
  font-size: 65px;
  line-height: 20px;
  color: #db0000;
  position: relative;
  right: 0;
  top: 5px;
}
#home-modal .modal-body {
  display: flex;
  justify-content: center;
}
#home-modal .modal-footer {
  display: none;
}
#home-modal .modal-header, #home-modal .modal-footer {
  border: none;
}
iframe {
  width: 100%;
  max-width: 854px;
  min-height: 240px;
}
@media (min-width: 1200px) {
  iframe {
    min-height: 480px;
  }
}
@media (min-width: 992px) {
  iframe {
    min-height: 480px;
  }
}
</style>